'use client';

import {
  Box,
  Link,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import { useRef } from 'react';

import { ReactComponent as ArroRightBlack } from '@/app/_icons/Ck_arrow_right_black24px.svg';
import { ReactComponent as ChevropDown } from '@/app/_icons/CkChevronDown.svg';
import { ReactComponent as CkClose } from '@/app/_icons/CkClose_black.svg';
import { PRE_OWNED_OPTIONS } from '@/hooks/routes-config';

import styles from './MegaMenu.module.scss';

function PreOwned() {
  const initRef = useRef<HTMLDivElement>(null);

  return (
    <Popover
      trigger="hover"
      placement="bottom"
      returnFocusOnClose={true}
      variant={'fullWidth'}
      initialFocusRef={initRef}
    >
      {({ onClose }) => (
        <>
          <PopoverTrigger>
            <Link
              role="link"
              href="javascript:void(0)"
              className={styles.megaMenuLink}
            >
              Pre-Owned
              <ChevropDown className={styles.menuIcon} />
            </Link>
          </PopoverTrigger>
          <PopoverContent
            bg="white"
            className={styles.megaMenuWrapper}
            width="100%"
            border="0"
            borderRadius="0"
            top={11}
            bottom="0"
            left="0"
            right="0"
            boxShadow="none"
            zIndex="auto"
          >
            <PopoverBody p={0}>
              <Box className={styles.megamenuHeader}>
                <Box className={styles.megamenuFilter}>
                  {PRE_OWNED_OPTIONS.map((option, index) => (
                    <Link
                      key={index}
                      role="link"
                      className={styles.badge}
                      href={option.url}
                      textTransform={'none'}
                    >
                      {option.title}
                    </Link>
                  ))}
                  <Box marginLeft={'auto'}>
                    <PopoverCloseButton
                      role="button"
                      className={styles.megamenuFilterClose}
                    >
                      <CkClose />
                    </PopoverCloseButton>
                  </Box>
                </Box>
              </Box>
              <Box className={styles.megamenuBodyWrap}>
                <Box className={styles.megamenuBody}>
                  <SimpleGrid
                    columns={[1, 2, 3, 3]}
                    spacingX={['20px', '40px', '40px', '40px']}
                    spacingY={['20px', '40px', '40px', '40px']}
                    alignItems={'flex-start'}
                  >
                    {PRE_OWNED_OPTIONS.map((option, index) => (
                      <Box
                        key={index}
                        className={styles.toolsCard}
                        textAlign={'center'}
                      >
                        <option.icon
                          className={styles.toolIcon}
                          width={40}
                          height={40}
                        />
                        <Link
                          href={option.url}
                          role="link"
                          className={styles.themeLink}
                          textTransform={'none'}
                        >
                          {option.title}
                          <ArroRightBlack className={styles.menuIcon} />
                        </Link>
                        <Text className={styles.toolDescription}>
                          {option.menu_description}
                        </Text>
                      </Box>
                    ))}
                  </SimpleGrid>
                </Box>
              </Box>
              <Box onClick={onClose} ref={initRef} className={styles.overlay} />
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
}

export default PreOwned;
